import { icons } from 'assets';
import Button from 'Components/shared/button';
import FormControl from 'Components/shared/control';
import { InputWithAdornment } from 'Components/shared/inputs';
import { ErrorModal } from 'Components/shared/successful/ErrorModal';
import Text from 'Components/shared/text';
import React, { useRef, useState } from 'react'
import { registerAction } from 'services/authService';
import AuthCodeInput from './AuthCodeInput';
import Back from './Back';
import styles from './registeration.module.css';
const StageFour = ({ onNext, onPrev, values, errors, touched, handleChange, handleUpdate,}) => {
    
        const [subStage, setSubStage] = useState(0);
        const [isLoading, setIsLoading] = useState(false)
        
        const [isPasswordVisible, setIsPasswordVisible] = useState(false);
        const [errorModal, setErrorModal] = useState("");
       
        const sendVerificationHandler = () => {
            // Send Verification and then go to the next  sub step
            setSubStage(1);
        }

        const handleRegister = async(e) => {
            setIsLoading(true)
           
            const firstName = values.fullName.trim().split(" ")[0];
            const lastName = values.fullName.split(" ").length > 2 ? values.fullName.trim().split(" ")[2] : values.fullName.trim().split(" ")[1]
            const body = {
                email: values.email,
                phone: values.countryCode + parseInt(values.phoneNo),
                country: values.country,
                password: values.password,
                pin: values.pin,
                firstName,
                lastName
            }
            console.log(body);
            try{
                setErrorModal("")
                const {data:{data, status,message}, status:statusCode} = await registerAction(body);
                console.log(data, status, message)
                if(status === "Ok"){
                    onNext(e, values.email, values.password)

                }
            }
            catch(err){
                setErrorModal(err?.message)
            }
            finally{
                setIsLoading(false);
            }
            
        }
     
       
        let renderEl = (
            <>
            <Back onClick={onPrev} />
                <Text className={styles.Text} variant="xl" color="primary" style={{width:"420px"}}>
                Create your password
                </Text>
                <FormControl fullWidth label="Password"
                style={{marginTop:"25px"}}>
                    <div className='row-start w-full' style={{gap:"1rem"}}>
                        <InputWithAdornment right={<img onClick={(e) => setIsPasswordVisible(prev => !prev)}
                        src={isPasswordVisible ? icons.eye_close : icons.open_eye}  
                        width="16px" height="16px" alt="make visible"  style={{cursor:"pointer"}}/>}
                        type={isPasswordVisible ? "text":"password"}fullWidth 
                        error={errors.password}
                        success={(!errors.password && touched.password) && "Now, that's a secure password."}
                        placeholder="Enter password" 
                        {...handleUpdate()}
                        name="password"
                        />
                    
                    </div>
                </FormControl>
                <FormControl fullWidth>
                    <Button label="Continue"
                    disabled={errors.password && touched.password}
                     onClick={sendVerificationHandler} fullWidth/>
                </FormControl>
            </>
        )
        if(subStage === 1){
            renderEl = (
                <>
                 <Back onClick={() => setSubStage(0)} />
                 <Text className={styles.Text} variant="xl" color="primary" style={{width:"400px"}}>
                 Set up transaction pin 
                </Text>
                <Text color="secondary" variant="md" style={{padding:'20px', width:"426px"}} >
                Transaction pin  are used to authorize any transaction you do in the application
                </Text>
                    <div style={{padding:"20px"}}>
                        <AuthCodeInput onChange={text => handleChange({target:{name:"pin", value:text}})} numberOfChar={4}/>

                    </div>
                   <Text style={{color:"var(--secondary-color)", paddingLeft:"20px"}}>Do not forget this pin because it is going to be use on all your transactions</Text>
                <FormControl fullWidth>
                    <Button label="Continue" onClick={handleRegister} fullWidth disabled={!!errors.pin} loading={isLoading}/>
                </FormControl>
                <ErrorModal message={errorModal} openModal={!!errorModal} setErrorModal={setErrorModal}/>
                </>
            )
        }
        return (
            <div className={styles.StageFour}>
                {renderEl}
            </div>
        )
    
}

export default StageFour;